import config from '../../../config';
import { extractGamesFromController } from '../../../utils/jackpotsV2/extractGamesFromController';
import { getJackpotsV2ForGames } from '../../../utils/jackpotsV2/getJackpotsV2ForGames';
import { LogicContext } from '../types';

export const getJackpotsV2 = async (context: LogicContext) => {
  if (config?.features?.jackpotsV2?.mode !== 'enabled') {
    return {};
  }
  const { controllersData } = context;
  const allGames = extractGamesFromController(controllersData?.categories);
  const currency = context.user?.currency || config.default_currency;
  return getJackpotsV2ForGames(allGames, currency);
};
